module.exports = __webpack_public_path__ + "static/media/evoETH.66eb05d4.svg";